export enum Departments {
    SALES='SALES',
    SERVICE='SERVICE',
    PARTS='PARTS'
}
